import { CloseScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => {
    return overlay.scrollStrategies.close();
  };
}

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
  ],
})
export class SharedUtilAutocompleteModule {}
